import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

const ServicesSectionForHome = () => {


  const [items, setItems] = useState([]);
  const [service, setService] = useState([]);


  const [page, setPage] = useState([]);
  const { pageSlug } = useParams(); // Extract the blog post titleSlug from the URL


  useEffect(() => {
    fetch(`https://aprilone-178ea8362c0b.herokuapp.com/page/${pageSlug}`)
      .then((res) => res.json())
      .then((info) => setPage(info))
      .catch((error) => console.error("Error fetching banners:", error));
  }, []);


  useEffect(() => {
    fetch(`https://aprilone-178ea8362c0b.herokuapp.com/service-items`)
      .then((res) => res.json())
      .then((info) => setItems(info));
  }, []);


  useEffect(() => {
    fetch(`https://aprilone-178ea8362c0b.herokuapp.com/service`)
      .then((res) => res.json())
      .then((info) => setService(info));
  }, []);


  return (



    <><div>

      {/* Features about */}
      <section className="feature-aboutsection about-section" id="services-sec">
        <div className="container">
          <figure className="mb-0 price-circle">
            <img className="img-fluid" src="./assets/images/price-circle.png" alt />
          </figure>
          <div className="row">
            {
              service.map(e => e.pageSlug === '' && <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                <div className="feature_aboutheading">
                  <h4 className='heading-color text-center'>{e.servicesubHeading}</h4>
                  <h2>{e.serviceHeading}</h2>
                </div>
              </div>)}
          </div>
          <div className="feature-block">
            <div className="row" data-aos="fade-up">
              <figure className="mb-0 price-sidecircle">
                <img className="img-fluid" src="./assets/images/price-sidecircle.png" alt />
              </figure>
              {
                items.map(b => b.pageSlug === '' && <div className="col-lg-4 col-md-4 col-sm-12 col-12">
                  <div className="feature_aboutcontent box hover1">
                    <div className="icon-size1">
                      <figure className="mb-0 feature-friendicon">
                        <img src={b.serviceIcon} alt className="img-fluid" />
                      </figure>
                    </div>
                    <h5>{b.serviceTitle}</h5>
                    <p className="mb-0 text-size-18">{b.serviceDetails}</p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </section>
    </div>
    </>

  );
};

export default ServicesSectionForHome;
